export default __webpack_public_path__ + "static/media/List-documentation.9b5d1580.md";